import Title from "antd/es/typography/Title";
import React, { useState } from "react";
import "./index.scss";
import { ArrowRightOutlined } from "@ant-design/icons";
import JoinWaitlistModal from "../../../../Components/JoinWaitlist";

const Banner = () => {
  const [isWaitlistOpen, setIsWaitlistOpen] = useState(false);
  const closeWaitlist = () => setIsWaitlistOpen(false);

  return (
    <div className="home-banner-wrapper" id="home">
      <div className="home-banner-container">
        <Title level={1} className="hero_heading">
          Confidentially Connect
        </Title>
        <Title level={1} className="hero_heading">
          <span className="secondary-text">Top Talent and Breakout Companies</span>
        </Title>
        <Title level={4} className="hero_text" style={{ marginTop: "0px" }}>
          Exclusive opportunities at breakout companies for high-slope GTM and
          technical talent—anonymously, until there's a match.
        </Title>
        <div className="hero-btn-wrapper">
          <a
            href="https://candidate.stealthjobs.co/"
            target="_blank"
            rel="noreferrer"
            className="hero-cta hero-cta--primary"
          >
            <span className="hero-cta-title">
              Apply Now <ArrowRightOutlined />
            </span>
            <span className="hero-cta-subtitle">
              I want to get hired confidentially
            </span>
          </a>
          <a
            href="https://employer.stealthjobs.co/"
            target="_blank"
            rel="noreferrer"
            className="hero-cta hero-cta--secondary"
          >
            <span className="hero-cta-title">
              I'm Recruiting <ArrowRightOutlined />
            </span>
            <span className="hero-cta-subtitle">
              I want to hire confidentially
            </span>
          </a>
        </div>
        <button
          type="button"
          className="hero-waitlist-link"
          onClick={() => setIsWaitlistOpen(true)}
        >
          Join the Waitlist
        </button>
      </div>
      <JoinWaitlistModal
        isModalOpen={isWaitlistOpen}
        handleOk={closeWaitlist}
        handleCancel={closeWaitlist}
        defaultValue="seeker"
        setIsModalOpen={setIsWaitlistOpen}
      />
    </div>
  );
};

export default Banner;
